import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom';
import swal from 'sweetalert';
import constant from '../../constant';
import { capitalizeWords, onChange, setError, setOptions, validateForm } from '../../utils';
import AsideRightMenu from '../Dashboard/AsideRightMenu';
import queryString from 'query-string';
import Loader from '../Common/Loader';
import { Typeahead } from 'react-bootstrap-typeahead';
import { citySearch, jobQuestionList, searchSkill } from '../../action/jobs';

class Onboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            FIRST_NAME: { name: "FIRST_NAME", value: "", error: '', isRequired: true, },
            LAST_NAME: { name: "LAST_NAME", value: "", error: '', isRequired: true, },
            MOBILE_NUMBER: { name: "MOBILE_NUMBER", value: "", error: '', isRequired: true, },
            EMAIL: { name: "EMAIL", value: "", error: '', isRequired: true, },
            WORK_STATUS: { name: "WORK_STATUS", value: "", error: '', isRequired: true, },
            RESUME: { name: "RESUME", value: "", error: '', isRequired: true, },
            SALARY_IN_LAKH: { name: "SALARY_IN_LAKH", value: "", error: '', isRequired: true, },
            SALARY_IN_THOUSAND: { name: "SALARY_IN_THOUSAND", value: "", error: '', isRequired: true, },
            TOTAL_EXPERIENCE_YEAR: { name: "TOTAL_EXPERIENCE_YEAR", value: "", error: '', isRequired: true, },
            TOTAL_EXPERIENCE_MONTH: { name: "TOTAL_EXPERIENCE_MONTH", value: "", error: '', isRequired: true, },
            LOCATION: { name: "LOCATION", value: "", error: '', isRequired: true, },
            NOTICE_PERIOD: { name: "NOTICE_PERIOD", value: "", error: '', isRequired: true, },
            SELECTED_SKILLS: [],
            KEYWORDS: {
                name: "KEYWORDS",
                value: [],
                options: [],
                error: "",
                isRequired: true,
            },


        }

    }
    onChange = (e) => {
        const { name, value } = e.target;
        onChange(this, name, value)
    }
    onFileUpload = (e) => {
        let files = e.target.files
        if (files && files.length) {
            if (files[0].size <= 5000000 && (files[0].type == "application/pdf" || files[0].type == "application/msword" || files[0].type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document")) {
                onChange(this, this.state.RESUME.name, files[0])
            }
            else {
                onChange(this, this.state.RESUME.name, null)
                swal({
                    icon: "error",
                    text: "File size must be less than 5 MB. File Type must be PDF, DOC, DOCX.",
                    timer: 2000,
                    showCancelButton: false,
                    showConfirmButton: false,
                });
            }

        }
    }


    onKeywordPress = (value, TYPE) => {
        if (TYPE === "LOCATION") {
            citySearch(value).then((res) => {
                if (res.status) {
                    setOptions(this, this.state.CITY.name, res.result);
                } else {
                    alert(res.error);
                }
            });
        } else if (TYPE === "QUESTION") {
            jobQuestionList(value).then((res) => {
                if (res.status) {
                    setOptions(this, this.state.QUESTION.name, res.result);
                } else {
                    alert(res.error);
                }
            });
        } else if (TYPE === "SKILL") {
            searchSkill(value).then((res) => {
                if (res.status) {
                    setOptions(this, this.state.KEYWORDS.name, res.result);
                } else {
                    alert(res.error);
                }
            });
        }
    };


    skillsOnChange = (e) => {

        function getUniqueListBy(arr, key) {
            return [...new Map(arr.map((item) => [item[key], item])).values()];
        }
        let val = [];
        if (e.length > 0) {
            val = e[e.length - 1];
        }
        onChange(this, this.state.KEYWORDS.name, val);
        if (e[0]) {
            val = this.state.SELECTED_SKILLS.concat(val);
            val = val.map((item, index) => {
                if (item.SKILL) {
                    return { SKILL: item.SKILL };
                } else if (item.label) {
                    return { SKILL: item.label };
                }
            });
            val = getUniqueListBy(val, "SKILL");
            this.setState({ SELECTED_SKILLS: val });
        }
    };
    deleteSKills = (SKILL) => {
        const { SELECTED_SKILLS } = this.state;
        let arr = SELECTED_SKILLS.filter((item) => {
            if (item.SKILL != SKILL) {
                return item;
            }
        });
        this.setState({ SELECTED_SKILLS: arr });
        onChange(this, this.state.KEYWORDS.name, arr)
    };


    onSubmit = (e) => {
        e.preventDefault();

        const { FIRST_NAME, LAST_NAME, MOBILE_NUMBER, EMAIL, WORK_STATUS, RESUME, SALARY_IN_LAKH, SALARY_IN_THOUSAND, LOCATION, KEYWORDS, TOTAL_EXPERIENCE_YEAR, TOTAL_EXPERIENCE_MONTH, NOTICE_PERIOD, SELECTED_SKILLS } = this.state;
        if (validateForm(this)) {
            debugger
            if (this.state.MOBILE_NUMBER.value.length == 10 || this.state.MOBILE_NUMBER.value.length == 13) {

                const qParams = queryString.parse(this.props.location.search)
                const formData = new FormData();
                formData.append('FIRST_NAME', FIRST_NAME.value);
                formData.append('LAST_NAME', LAST_NAME.value);
                formData.append('MOBILE_NUMBER', MOBILE_NUMBER.value);
                formData.append('EMAIL', EMAIL.value);
                formData.append('WORK_STATUS', WORK_STATUS.value);
                formData.append('SALARY_IN_LAKH', SALARY_IN_LAKH.value);
                formData.append('SALARY_IN_THOUSAND', SALARY_IN_THOUSAND.value);
                formData.append('LOCATION', LOCATION.value);
                formData.append('TOTAL_EXPERIENCE_YEAR', TOTAL_EXPERIENCE_YEAR.value);
                formData.append('TOTAL_EXPERIENCE_MONTH', TOTAL_EXPERIENCE_MONTH.value);
                formData.append('NOTICE_PERIOD', NOTICE_PERIOD.value);
                formData.append('SKILLS', SELECTED_SKILLS.map(item => {
                    return `'` + item.SKILL + `'`
                }).join(','));
                formData.append('JOB_ID', qParams.id)
                formData.append('resume', RESUME.value)
                console.log(SELECTED_SKILLS)
                this.props.onSubmit(formData)
            }
            else {
                setError(this, MOBILE_NUMBER.name, 'invalid Phone Number')
            }
        }



    }

    render() {
        const { FIRST_NAME, LAST_NAME, MOBILE_NUMBER, EMAIL, WORK_STATUS, RESUME, SALARY_IN_LAKH, SALARY_IN_THOUSAND, LOCATION, KEYWORDS, TOTAL_EXPERIENCE_YEAR, TOTAL_EXPERIENCE_MONTH, NOTICE_PERIOD, SELECTED_SKILLS } = this.state;
        const { showLoader } = this.props;
        const qParam = queryString.parse(this.props?.location?.search)

        return (
            <React.Fragment>
                <section className="pricing-area padding-top-100px padding-bottom-80px">
                    {showLoader && <Loader />}
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3 mt-3">
                                <AsideRightMenu />
                            </div>

                            <div className="col-md-9">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="breadcrumb-content d-flex flex-wrap justify-content-between align-items-center" style={{ marginTop: '5px', marginBottom: '10px' }} >

                                            <ul className="list-items d-flex align-items-center">
                                                <li className="active__list-item text-secondary">
                                                    <Link to={constant.component.JobList.url + '?f=ALL&l=10&p=1'} className="text-secondary">
                                                        Jobs and Responses
                                                    </Link>
                                                </li>
                                                <li className="active__list-item text-secondary">
                                                    <Link to={constant.component.JobApplicationList.url + `${this.props.location.search + '&l=10&p=1&s=all'}`
                                                    } className="text-secondary">
                                                        Applications
                                                    </Link>

                                                </li>
                                                <li className=" text-secondary">OnBoard ({capitalizeWords(qParam.job.split('-')).join(' ')})</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="billing-form-item mb-0">
                                    <div className="row mt-2">
                                        <div className="col-lg-12">

                                            <div
                                                className="billing-title-wrap"
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                }}
                                            >
                                                <div>
                                                    <h3 className="widget-title pb-0">Candidate Onboarding - {capitalizeWords(qParam.job.split('-')).join(' ')}</h3>
                                                    <div className="title-shape margin-top-5px"></div>
                                                </div>
                                            </div>
                                            <div className="billing-content">
                                                <div className="postjob-form-action">
                                                    <form onSubmit={(e) => this.onSubmit(e)} >
                                                        <div className="row">
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        First Name{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <input
                                                                            className={
                                                                                FIRST_NAME.error.length > 0 ? "form-control is-invalid" : "form-control"
                                                                            }
                                                                            name={FIRST_NAME.name}
                                                                            value={FIRST_NAME.value}
                                                                            onChange={(e) => { this.onChange(e) }}

                                                                            type="text"
                                                                            placeholder="Enter First Name"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Last Name{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <input
                                                                            className={
                                                                                LAST_NAME.error.length > 0 ? "form-control is-invalid" : "form-control"
                                                                            }
                                                                            name={LAST_NAME.name}
                                                                            value={LAST_NAME.value}
                                                                            onChange={(e) => { this.onChange(e) }}

                                                                            type="text"
                                                                            placeholder="Enter Last Name"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Email{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <input
                                                                            className={
                                                                                EMAIL.error.length > 0 ? "form-control is-invalid" : "form-control"
                                                                            }
                                                                            name={EMAIL.name}
                                                                            value={EMAIL.value}
                                                                            onChange={(e) => { this.onChange(e) }}

                                                                            type="text"
                                                                            placeholder="Enter Email"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Mobile No{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <input
                                                                            className={
                                                                                MOBILE_NUMBER.error.length > 0 ? "form-control is-invalid" : "form-control"
                                                                            }
                                                                            name={MOBILE_NUMBER.name}
                                                                            value={MOBILE_NUMBER.value}
                                                                            onChange={(e) => { this.onChange(e) }}
                                                                            type="text"
                                                                            placeholder="Enter Mobile No"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Location{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <input
                                                                            className={
                                                                                LOCATION.error.length > 0 ? "form-control is-invalid" : "form-control"
                                                                            }
                                                                            name={LOCATION.name}
                                                                            value={LOCATION.value}
                                                                            onChange={(e) => { this.onChange(e) }}
                                                                            type="text"
                                                                            placeholder="Enter Location"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Notice Period{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <input
                                                                            className={
                                                                                NOTICE_PERIOD.error.length > 0 ? "form-control is-invalid" : "form-control"
                                                                            }
                                                                            name={NOTICE_PERIOD.name}
                                                                            value={NOTICE_PERIOD.value}
                                                                            onChange={(e) => { this.onChange(e) }}
                                                                            type="text"
                                                                            placeholder="Enter Notice Period"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Salary{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group d-flex" >
                                                                        <select
                                                                            className={
                                                                                SALARY_IN_LAKH.error.length > 0 ? "form-control is-invalid" : "form-control mr-2"
                                                                            }
                                                                            name={SALARY_IN_LAKH.name}
                                                                            value={SALARY_IN_LAKH.value}
                                                                            onChange={(e) => { this.onChange(e) }}
                                                                        >
                                                                            <option value="">-- Salary In Lacs --</option>
                                                                            {
                                                                                Array.from({ length: 200 }, (_, i) => <option value={i + 0}>{i + 0} Lacs </option>)
                                                                            }
                                                                        </select>

                                                                        <select
                                                                            className={
                                                                                SALARY_IN_THOUSAND.error.length > 0 ? "form-control is-invalid" : "form-control"
                                                                            }
                                                                            name={SALARY_IN_THOUSAND.name}
                                                                            value={SALARY_IN_THOUSAND.value}
                                                                            onChange={(e) => { this.onChange(e) }}
                                                                        >
                                                                            <option value="">-- Salary In Thousands --</option>
                                                                            {
                                                                                Array.from({ length: 100 }, (_, i) => <option value={i + 0}>{i + 0} Thousands </option>)
                                                                            }
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Expereience{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group d-flex" >
                                                                        <select
                                                                            className={
                                                                                TOTAL_EXPERIENCE_YEAR.error.length > 0 ? "form-control mr-2 is-invalid" : "form-control mr-2"
                                                                            }
                                                                            name={TOTAL_EXPERIENCE_YEAR.name}
                                                                            value={TOTAL_EXPERIENCE_YEAR.value}
                                                                            onChange={(e) => { this.onChange(e) }}
                                                                        >
                                                                            <option value="">-- Experience in Years --</option>
                                                                            {
                                                                                Array.from({ length: 50 }, (_, i) => <option value={i + 1}>{i + 1}  years </option>)
                                                                            }

                                                                        </select>

                                                                        <select
                                                                            className={
                                                                                TOTAL_EXPERIENCE_MONTH.error.length > 0 ? "form-control is-invalid" : "form-control"
                                                                            }
                                                                            name={TOTAL_EXPERIENCE_MONTH.name}
                                                                            value={TOTAL_EXPERIENCE_MONTH.value}
                                                                            onChange={(e) => { this.onChange(e) }}
                                                                        >
                                                                            <option value="">-- Experience in Month --</option>
                                                                            {
                                                                                Array.from({ length: 12 }, (_, i) => <option value={i}>{i}  months </option>)
                                                                            }

                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Work Status{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group postjob-select-container">
                                                                        <select
                                                                            className={
                                                                                WORK_STATUS.error.length > 0
                                                                                    ? "postjob-select is-invalid"
                                                                                    : "postjob-select"
                                                                            }
                                                                            name={WORK_STATUS.name}
                                                                            value={WORK_STATUS.value}
                                                                            onChange={(e) => { this.onChange(e) }}
                                                                        >
                                                                            <option selected value=''>Choose Work Status</option>
                                                                            <option value='F'>Fresher</option>
                                                                            <option value='E'>Experienced</option>
                                                                        </select>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Resume{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <input
                                                                            className={RESUME.error.length > 0 ?
                                                                                "form-control is-invalid" : 'form-control'
                                                                            }
                                                                            onChange={(e) => {
                                                                                this.onFileUpload(e)
                                                                            }}
                                                                            type="file"
                                                                            placeholder="Mention the Primary Email"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>  <div className='col-lg-6 column-lg-full'>
                                                                <div className="form-group">
                                                                    <label className="label-text">
                                                                        Skills{" "}
                                                                        <span className="text-danger font-size-16">
                                                                            *
                                                                        </span>
                                                                    </label>
                                                                    <Typeahead
                                                                        id="ta-skill-ids"
                                                                        allowNew={false}
                                                                        clearButton={false}
                                                                        labelKey={(option) => `${option.SKILL}`}
                                                                        multiple={true}
                                                                        options={KEYWORDS.options}
                                                                        onInputChange={(e) => {
                                                                            this.onKeywordPress(e, "SKILL");
                                                                        }}
                                                                        onChange={(e) => {
                                                                            this.skillsOnChange(e);
                                                                        }}
                                                                        placeholder="Add New Skill"
                                                                        className={
                                                                            KEYWORDS.error.length > 0
                                                                                ? "errorMsg"
                                                                                : ""
                                                                        }
                                                                        emptyLabel
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 column-lg-full">
                                                                <div className="input-box">
                                                                    <label className="label-text">
                                                                        Selected Skills{" "}
                                                                        <span className="text-danger font-size-16">

                                                                        </span>
                                                                    </label>
                                                                    <div className="form-group">
                                                                        <label className="label-text">
                                                                            {SELECTED_SKILLS.map((item) => {
                                                                                return (
                                                                                    <span className="locationbox">
                                                                                        {item.SKILL}{" "}
                                                                                        <i
                                                                                            onClick={() => {
                                                                                                this.deleteSKills(item.SKILL);
                                                                                            }}
                                                                                            className="fa fa-close"
                                                                                        ></i>
                                                                                    </span>
                                                                                );
                                                                            })}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row sq-db2">
                                                                <div className="col-lg-12 pl-4 sq-db2">
                                                                    <div className="btn-box mt-4 pl-1 sq-db2">
                                                                        <button type="submit" disabled={showLoader} style={showLoader ? { backgroundColor: '#4c4c4c' } : {}} className="theme-btn border-0">
                                                                            <i className="la la-plus sq-db2"></i> Submit
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
            </React.Fragment>
        )
    }
}
export default withRouter(Onboard)